export const defaultLocale = "en";
export const locales = [
  "en",
  "fr",
  "es",
  "it",
  "de",
  "pt",
  "tr",
  "el",
] as const;

export type Locale = (typeof locales)[number];

// CUSTOMIZE: Add labels for each supported locale
export const languageLabels: Record<string, string> = {
  en: "English",
  fr: "Français",
  es: "Español",
  it: "Italiano",
  de: "Deutsch",
  pt: "Português",
  tr: "Türkçe",
  el: "Ελληνικά",
};
